import React from 'react';

/** Tiles isométricos do mark (fundo transparente). Em `public/brand/`. */
export const BRAND_TILE_PREDIO_SRC = '/brand/tile-predio.png';
export const BRAND_TILE_PISCINA_SRC = '/brand/tile-piscina.png';
export const BRAND_TILE_PLANTA_SRC = '/brand/tile-planta.png';

export type BrandLogoAssembleSize = 'sm' | 'md' | 'lg' | 'xl';

export interface BrandLogoAssembleProps {
  size?: BrandLogoAssembleSize;
  /** Lado em px; sobrescreve o preset de `size` quando definido. */
  sizePx?: number;
  className?: string;
  /** Quando true, monta uma vez e respira; senão, ciclo contínuo de montagem. */
  once?: boolean;
  /** Texto acessível do estado de carregamento. */
  label?: string;
}

const SIZE_CLASS: Record<BrandLogoAssembleSize, string> = {
  sm: 'lp-brand-logo--sm',
  md: 'lp-brand-logo--md',
  lg: 'lp-brand-logo--lg',
  xl: 'lp-brand-logo--xl',
};

/**
 * Mark LivinPixel montado por três tiles (planta · prédio · piscina).
 * Coreografia: prédio ao centro, planta à esquerda e piscina à direita,
 * ambos alinhados pela base do prédio.
 */
export const BrandLogoAssemble: React.FC<BrandLogoAssembleProps> = ({
  size = 'lg',
  sizePx,
  className = '',
  once = false,
  label,
}) => {
  const compact = typeof sizePx === 'number' && sizePx <= 56;
  const classes = [
    'lp-brand-logo',
    sizePx == null ? SIZE_CLASS[size] : 'lp-brand-logo--custom',
    once ? 'lp-brand-logo--once' : 'lp-brand-logo--loop',
    compact ? 'lp-brand-logo--compact' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const style =
    sizePx != null
      ? ({ width: sizePx, height: sizePx } as React.CSSProperties)
      : undefined;

  return (
    <div
      className={classes}
      style={style}
      role={label ? 'img' : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
    >
      <div className="lp-brand-logo__glow" aria-hidden />
      <div className="lp-brand-logo__stage">
        {/* Z-order: prédio atrás; planta e piscina à frente (isometria). */}
        <img
          className="lp-brand-logo__tile lp-brand-logo__tile--predio"
          src={BRAND_TILE_PREDIO_SRC}
          alt=""
          decoding="async"
          draggable={false}
        />
        <img
          className="lp-brand-logo__tile lp-brand-logo__tile--planta"
          src={BRAND_TILE_PLANTA_SRC}
          alt=""
          decoding="async"
          draggable={false}
        />
        <img
          className="lp-brand-logo__tile lp-brand-logo__tile--piscina"
          src={BRAND_TILE_PISCINA_SRC}
          alt=""
          decoding="async"
          draggable={false}
        />
      </div>
    </div>
  );
};

export default BrandLogoAssemble;
